import * as React from 'react';

interface VideoProps {
  title: string;
  path: string;
  orientation: "landscape" | "portrait";
}

class Video extends React.Component<VideoProps> {
  render() {
    const { title, path, orientation } = this.props;
    return (
      <div className={`grid-child grid-child-${orientation}`}>
        {title}<br/>
        <div className={`video-container-${orientation}`}>
          <iframe
            src={path}
            width="100%" height="100%"
            allow="fullscreen">
          </iframe>
        </div>
      </div>
    );
  }
}

export default Video;